// extracted by mini-css-extract-plugin
export default {"results":"h2Stvm71"};